/* Publish by EComposer at 2026-10-01 08:44:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8brpw1rxtls"]=  window.__ectimmers["ecom-8brpw1rxtls"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8brpw1rxtls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8brpw1rxtls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8xx0alob2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8xx0alob2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tk3eomvkmih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tk3eomvkmih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tismult7cmt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tismult7cmt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7p5fgna11fg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7p5fgna11fg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2antb1pfsq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2antb1pfsq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47zqjpd2cwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47zqjpd2cwl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0tjvnly26pca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0tjvnly26pca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0upj47ap3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0upj47ap3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0s4gqq25glu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0s4gqq25glu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2lym00tl7qx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2lym00tl7qx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s14aopswk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s14aopswk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l79lo27hfae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l79lo27hfae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jfjvkeaprf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jfjvkeaprf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2va48kzh1y4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2va48kzh1y4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ku4ka0mhg4c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku4ka0mhg4c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-thfkfneqp0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-thfkfneqp0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ds5y9iadfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ds5y9iadfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rz1ahx15sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rz1ahx15sq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7809633jmm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7809633jmm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htcd7lyxal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htcd7lyxal', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im7bo236se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im7bo236se', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yrrieggcgwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yrrieggcgwh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3n4qupnssk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3n4qupnssk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9y39w8fhl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9y39w8fhl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3he5ebwg7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3he5ebwg7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6kz0zb0mdhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kz0zb0mdhr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s4u8vfgbani').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4u8vfgbani', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-094r31mht4wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-094r31mht4wc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-18n8ovxfn0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-18n8ovxfn0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d63sdbbqiro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d63sdbbqiro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7l7d127e5jl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7l7d127e5jl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkurzd3k19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkurzd3k19', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jr1jzdqdwwi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jr1jzdqdwwi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w4wxbf32z7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w4wxbf32z7n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7rkiwybfda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7rkiwybfda', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pyomj9jdo1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pyomj9jdo1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zxiz322azy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zxiz322azy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w95s3dilmjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w95s3dilmjs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h4uimw3ob47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h4uimw3ob47', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37ry5eboue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37ry5eboue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fizlnbsk2pr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fizlnbsk2pr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-59j9e76izy7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-59j9e76izy7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sxq48mzmcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sxq48mzmcc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhbox30viqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhbox30viqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-arhjygq0gpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-arhjygq0gpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48pdy7kqnsf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48pdy7kqnsf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q15z3tamcl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q15z3tamcl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tt4lyavod6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tt4lyavod6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6ic4bh4miq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6ic4bh4miq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-luz2ev7mdb8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-luz2ev7mdb8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8nbnehl2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8nbnehl2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uroj3hkz8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uroj3hkz8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf4px4hket').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf4px4hket', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gq8hbzupogt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gq8hbzupogt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4igqrvtd76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4igqrvtd76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1p7yw7nd3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1p7yw7nd3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp0fz9td3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp0fz9td3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4a902g3ljbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4a902g3ljbo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivaeuzxeweh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivaeuzxeweh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06trsdqt7u4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06trsdqt7u4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kihnl4sarep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kihnl4sarep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmnnf19con').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmnnf19con', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-za1qo0wxv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-za1qo0wxv8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zmoywuorkr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zmoywuorkr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t38eh03nej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t38eh03nej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlljs34wfpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlljs34wfpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vvqamwyskd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vvqamwyskd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llog4quk8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llog4quk8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71ru0855ku5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71ru0855ku5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7426wd59wfk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7426wd59wfk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvao7ahlkzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvao7ahlkzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rpvnjr5pi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rpvnjr5pi9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-prt0el408ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-prt0el408ta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgyur89dly').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgyur89dly', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-572ws4nirqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-572ws4nirqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kb3mv42wu4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kb3mv42wu4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ynox5brrsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynox5brrsu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zobv16v81bk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zobv16v81bk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3avbiyg3mar').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3avbiyg3mar', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1uoaw2rpnzk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1uoaw2rpnzk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v166bjkbjk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v166bjkbjk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-352g774rntk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-352g774rntk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o73rbl94o6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o73rbl94o6p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jfvupevape8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jfvupevape8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tp0o0rget5p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tp0o0rget5p', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-edq94atuv2v"]=  window.__ectimmers["ecom-edq94atuv2v"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const o=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},n=function(){e.removeEventListener("mousemove",o),e.removeEventListener("mouseup",n),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",o),e.addEventListener("mouseup",n)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",n)}

                    });
                    
                        document.querySelectorAll('.ecom-edq94atuv2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edq94atuv2v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4j49k9grnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4j49k9grnh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s4n9tgj3wzg"]=  window.__ectimmers["ecom-s4n9tgj3wzg"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-s4n9tgj3wzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s4n9tgj3wzg', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vb0luxoffd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vb0luxoffd', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3ki358a6ik6"]=  window.__ectimmers["ecom-3ki358a6ik6"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-3ki358a6ik6"]["hxog0c3l4"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-3ki358a6ik6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ki358a6ik6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4qbyl340vo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4qbyl340vo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1oc3c14nm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1oc3c14nm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sp3m17fbnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sp3m17fbnk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5yvc6wafz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5yvc6wafz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-piz104ksq9f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-piz104ksq9f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8c7rwmquwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8c7rwmquwp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ib1sesl9j1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ib1sesl9j1n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64gsokpogy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64gsokpogy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-omffr31c5zh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-omffr31c5zh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pb8g3al3j7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pb8g3al3j7p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsyiowimp8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsyiowimp8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5dv3223ejc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5dv3223ejc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptqrcemax1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptqrcemax1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5chz99qzrrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5chz99qzrrq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uf93sudvsvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uf93sudvsvg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-viug7no8ls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-viug7no8ls', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x07r8wrci1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x07r8wrci1i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yixax640ahs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yixax640ahs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7fpv0sycyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7fpv0sycyv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tocoyyqq5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tocoyyqq5o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f6ljxr7gesr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f6ljxr7gesr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1ra42j279f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1ra42j279f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1lgza2wi2vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1lgza2wi2vt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-au1afx9quzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-au1afx9quzm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsqc5rid42d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsqc5rid42d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pv3batjkvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pv3batjkvc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6u60fe0grm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6u60fe0grm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6twipssoun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6twipssoun', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ygtoptdi4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ygtoptdi4p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8i6zzdd8tmb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8i6zzdd8tmb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ceje0h2lvdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ceje0h2lvdm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e538vup2vy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e538vup2vy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wokslgdovs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wokslgdovs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-itv202cntoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-itv202cntoa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9t6atti71l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9t6atti71l', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-py9b1ypyj5h"]=  window.__ectimmers["ecom-py9b1ypyj5h"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-py9b1ypyj5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-py9b1ypyj5h', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-slpqz3qb20a"]=  window.__ectimmers["ecom-slpqz3qb20a"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-slpqz3qb20a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-slpqz3qb20a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l98hs4kkrv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l98hs4kkrv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p1kjftuybr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p1kjftuybr8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fubqb6w83kr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fubqb6w83kr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3aefal6c1hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3aefal6c1hj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6c5bj1jahfw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6c5bj1jahfw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e4dbqdlpyrv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e4dbqdlpyrv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ousgn6xt5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ousgn6xt5k', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ih6acmt66ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ih6acmt66ml', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xh5deay7bfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xh5deay7bfg', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c7eyne24lo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c7eyne24lo', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7slssyf6qxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7slssyf6qxx', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-muxt0mhlcbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-muxt0mhlcbr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bk9smc3lzhu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bk9smc3lzhu', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kfebowiytrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kfebowiytrh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h78ogosmems').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h78ogosmems', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frryhtvm27c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frryhtvm27c', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yp4je8d8b5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yp4je8d8b5f', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgx2xh7grq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgx2xh7grq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kpokubhvc7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kpokubhvc7h', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j265o8vpb78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j265o8vpb78', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4h7smkhay0y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4h7smkhay0y', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpcbyem6s6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpcbyem6s6f', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c0k1ex7iftb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c0k1ex7iftb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfenbgcwnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfenbgcwnn', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juhxhgctzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juhxhgctzi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4caehgesa63').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4caehgesa63', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxwyr0mdheq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxwyr0mdheq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hk51fw9l72a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hk51fw9l72a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4y0th1fo6qe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4y0th1fo6qe', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aeay7zcfaht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aeay7zcfaht', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edbaoye771').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edbaoye771', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w7wcluet6ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7wcluet6ml', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hrfhrhqhva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hrfhrhqhva', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v35wkppquv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v35wkppquv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gaweddsuw56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gaweddsuw56', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q1z74vu5amr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q1z74vu5amr', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}